<template>
  <div
    v-if="active"
    class="m-market-row"
  >
    <div class="m-outcome m-outcome-desc">
      <span class="m-outcome-desc-name">{{ getShowSpecifiers(market.specifiers) }}</span>
    </div>
    <template v-if="market.outcomes">
      <Outcome
        v-for="outcomeId in market.outcomes.order"
        :key="outcomeId"
        :outcome="market.outcomes.map[outcomeId]"
        :market="market"
        :event="event"
      />
    </template>

    <template v-else>
      <Outcome
        v-for="item in marketTitles.length"
        :key="item"
        :disabled="true"
      />
    </template>
  </div>
</template>

<script>
import Outcome from 'wap/match/Event/pagelet/Outcome'

const checkIsActive = (status) => {
  return +status === 0 || +status === 1
}

export default {
  components: {
    Outcome
  },
  props: {
    event: {
      type: Object,
      default: () => ({})
    },
    market: {
      type: Object,
      default: () => ({})
    },
    marketTitles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      timer: null,
      active: true
    }
  },
  watch: {
    'market.status'(val) {
      this.timer && clearTimeout(this.timer)
      if (checkIsActive(val)) {
        this.active = true
      } else {
        this.timer = setTimeout(() => {
          this.active = false
        }, 5000)
      }
    }
  },
  methods: {
    getShowSpecifiers(specifiers) {
      return specifiers ? specifiers.split('=')[1] : this.market.marketTypeDesc
    }
  }
}
</script>
